<template>
  <div id="loginContainer">
    <Header id="AzureLogin">
      <Row class="titleArea" style="font-size: 25px; margin-left: 85%">
        <Col offset="18">
          <Button
            style="position: fixed; margin-right: 80px; margin-top: 10px"
            @click="logout()"
            >Sign Out</Button
          >
        </Col>
      </Row>
    </Header>
  </div>
</template>

<script>
import APIUtil from "../util/APIUtil";
import axios from "axios";
import ien from 'view-design/dist/locale/en-US';
import izh from 'view-design/dist/locale/zh-CN';
export default {
  data() {
    return {};
  },
  mounted() {
    this.getALLlang();
    // 清空当前页面定义
    // this.$store.commit("clearAllAdDonotNeed");
    //Azure登录
    if (this.$msal.isAuthenticated) {
      var me = this;
      let adid = null;
      if (this.$msal.data.user.idToken) {
        adid = this.$msal.data.user.idToken.preferred_username;
      }
      console.log("----ad This is msal.data.user----");
      if (adid) {
        console.log("-----------This is adid-----------");
        APIUtil.userAuth(this, adid, "123456", "1").then((result) => {
          if (result) {
            sessionStorage.setItem("userInfo", JSON.stringify(result.userInfo));
            // me.$router.push(this.generateNextUrl());
            if(this.$route.query.loginType  && this.$route.query.loginType == '1'){
              me.$router.push("E97C32785C9AE39059617F3F1DC697B475A259E7C679B2FA/A3FFBEBFDB713E27");
            }else if(this.$route.query.loginType  && this.$route.query.loginType == '2'){
              // me.$router.push("C0F994D621530A70/A3FFBEBFDB713E27"); 
               me.$router.push("/61AB63E6DE1EF633AB0757BB3048AF07B7578999FE53335EBA610C6A6F738319/A3FFBEBFDB713E27");
            }else if(this.$route.query.loginType  && this.$route.query.loginType == '3'){
                  this.$router.push({
                    path: "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27",
                    query: {}
                  });
                  if(result.pageId=='0'){
                    this.$Message.info("菜单权限不足，请联系管理员");
                  }
            }else{
              if(result.pageId=='0'){
                    this.$router.push({
                      path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
                      query: {}
                    });
                  }else {
                    this.$router.push({
                      path: "/FD6C8EC28FA87153/A3FFBEBFDB713E27",
                      query: {}
                    });
                  }
            }
          }
        });
      } else {
        console.log("-----------Don't Have adid-----------");
        this.$msal.signIn();
      }
    }
    
  },
  methods: {
    adlogin() {
      this.$msal.signIn();
    },

    logout() {
      if (this.$msal.isAuthenticated) {
        this.$msal.signOut();
      }
    },
    getALLlang(){
        let Obj = {
          viewType:"Carlsberg",
          beUsed : "1"
        } 
        axios.post('/International/applySelectViewSet',Obj).then((res) => {
          this.$store.state.zhJson={...res.data[0],...izh}
          this.$store.state.enJson={...res.data[1],...ien}
          sessionStorage.setItem('enJson',JSON.stringify({...res.data[1],...ien}))
          sessionStorage.setItem('zhJson',JSON.stringify({...res.data[0],...izh}))
          this.$i18n.setLocaleMessage('zh', {...res.data[0],...izh});
          this.$i18n.setLocaleMessage('en', {...res.data[1],...ien});
        })
      },
    // 生成下一个页面
    generateNextUrl() {
      // 次页面
      var nextPage = this.$store.getters.siteInfo.defaultPageid;
      // 页面组ID
      var groupId = this.$route.params.group_id;
      // 页面ID
      var pageId = this.$route.params.page_id;
      // 站点ID
      var siteId = this.$route.params.site_id;
      if (groupId) {
        nextPage = "/" + groupId + "/" + pageId;
        if (siteId) {
          nextPage = "/" + siteId + nextPage;
        }

        if (this.$route.query) {
          let isFirst = true;
          for (let key in this.$route.query) {
            if (isFirst) {
              nextPage = nextPage + "?";
            } else {
              nextPage = nextPage + "&";
            }
            nextPage = nextPage + key + "=" + this.$route.query[key];
            isFirst = false;
          }
        }
      }
      nextPage = nextPage+'?loginType=1'
      return nextPage;
    },
  },
};
</script>

<style scoped>
#AzureLogin {
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
}
#loginContainer {
  position: fixed;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: Center;
  background-image: url("../assets/loginBack.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

@media (max-width: 576px) {
  #loginContainer {
    background-image: url("../assets/loginBack2.jpg");
  }
}

#loginContainer .loginArea {
  background-color: rgba(0, 0, 0, 0.4);
  width: 420px;
  border-radius: 5px;
  padding: 0px;
}

#loginContainer .titleArea {
  margin: 5px 0px 20px 0px;
}

#loginContainer .titleArea .title {
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
}

#loginContainer .titleArea .subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

#loginContainer .loginTypeArea {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding: 0px 5px;
  margin: 20px 0px 0px 0px;
}

#loginContainer .loginTabs /deep/ .ivu-tabs-nav {
  float: none;
  display: flex;
}

#loginContainer .loginTabs /deep/ .ivu-tabs-nav .ivu-tabs-tab {
  flex: 1;
  text-align: center;
}

#loginContainer .loginFormArea {
  padding: 15px 50px 25px 50px;
}

#loginContainer .ivu-input-group-prepend {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-right: 0px;
  color: rgba(255, 255, 255, 0.8);
}

#loginContainer .icon {
  font-size: 16px;
}

#loginContainer input {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.8);
}

#loginContainer button {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginPageAzure.vue